import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4247454f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "notifications",
  "data-scoped-css-v3": ""
}
const _hoisted_2 = ["data-js", "onMouseenter", "onMouseleave", "onFocusin", "onFocusout"]
const _hoisted_3 = { class: "p-y-2 p-x-3" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "newicon-close" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

import { onBeforeMount, watch } from 'vue';
import { Notification } from '../../types';


export default /*#__PURE__*/_defineComponent({
  props: {
    notifications: null
  },
  emits: ["close", "stopTimer", "restartTimer"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#notifications" }, [
    _createVNode(_Transition, { name: "notifications" }, {
      default: _withCtx(() => [
        (__props.notifications.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.notifications, (notification) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: notification.id,
                  "data-js": notification.id,
                  class: _normalizeClass(`notifications_item m-t-3 theme theme-light--7 notifications_item__${
            notification.type
          } ${notification.type === 'warning' && 'button--cta-primary'}`),
                  onMouseenter: ($event: any) => (_ctx.$emit('stopTimer', notification.id)),
                  onMouseleave: ($event: any) => (_ctx.$emit('restartTimer', notification.id)),
                  onFocusin: ($event: any) => (_ctx.$emit('stopTimer', notification.id)),
                  onFocusout: ($event: any) => (_ctx.$emit('restartTimer', notification.id))
                }, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(notification.content), 1),
                  _createElementVNode("button", {
                    class: _normalizeClass(`notifications_close p-2 notifications_close__${notification.type}`),
                    onClick: ($event: any) => (_ctx.$emit('close', notification.id))
                  }, _hoisted_6, 10, _hoisted_4)
                ], 42, _hoisted_2))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})